export const BaseDict = {
    Example: "Translated Example"
};
//# sourceMappingURL=dict.js.map